import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { JgLoadInspReportFile } from '../models/jg/jg-load-insp-report-file.model';
import { GlobalService } from '../providers/global.service';
import { RequestService } from '../providers/request/request.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class JgLoadInspReportFileService extends RequestService<JgLoadInspReportFile> {
  static PATH = '/jg/loadInsp/report/file';
  constructor(
    public override httpClient: HttpClient,
    private globalService: GlobalService,
  ) {
    super(httpClient, JgLoadInspReportFileService.PATH, globalService.debugUrl);
  }

  listBySectionItemId(sectionItemId: number) {
    return this.httpClient.get<JgLoadInspReportFile[]>(
      `${
        this.globalService.debugUrl
          ? this.globalService.debugUrl
          : environment.host
      }${JgLoadInspReportFileService.PATH}/listBySectionItemId/${sectionItemId}`,
    );
  }
}
